// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ViewAll.module.css - Netflix-inspired dark theme with red accents */
.ViewAll_container__zjhtL {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #141414;
  color: #ffffff;
  min-height: 100vh;
  padding-top: 5rem !important;
  overflow-x: hidden;
}

.ViewAll_header__bu4ai {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 12px;
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.ViewAll_header__bu4ai h1 {
  font-size: 20px;
  margin: 0;
  color: #E50914;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.ViewAll_booksGrid__vS0E2 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 16px;
  padding: 0 2rem;
  max-width: 1400px;
  margin: 0 auto 3rem auto;
}

.ViewAll_bookCard__-gbYz {
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  background-color: #181818;
  height: 100%;
}

.ViewAll_bookCard__-gbYz:hover {
  transform: scale(1.05);
  z-index: 2;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
}

.ViewAll_bookImageContainer__gXGU- {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 150%; /* Netflix-style aspect ratio */
}

.ViewAll_bookImage__o7yIZ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.ViewAll_bookInfo__Vph5r {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
  color: white;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ViewAll_bookCard__-gbYz:hover .ViewAll_bookInfo__Vph5r {
  opacity: 1;
}

.ViewAll_bookTitle__Ze5aU {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
}

.ViewAll_chapterCount__6Qw8n {
  font-size: 12px;
  margin: 0;
  color: #cccccc;
}

.ViewAll_premiumBadge__rFdEW {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #E50914;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 600;
  z-index: 1;
}

.ViewAll_pagination__AsFrK {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 32px;
  gap: 16px;
  padding-left: 1rem;
  padding-right: 1rem;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.ViewAll_paginationButton__42lMZ {
  padding: 8px 16px;
  background-color: #E50914;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-weight: 500;
}

.ViewAll_paginationButton__42lMZ:hover {
  background-color: #b2070f;
}

.ViewAll_paginationButton__42lMZ:disabled {
  background-color: #333333;
  cursor: not-allowed;
}

.ViewAll_pageInfo__Okbu1 {
  font-size: 14px;
  color: #cccccc;
}

.ViewAll_loading__9FBWs {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  font-size: 18px;
  color: #E50914;
}

.ViewAll_error__Q6V-5, .ViewAll_noResults__P8wpC {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #E50914;
  font-size: 18px;
  margin: 2rem 0;
}

/* Netflix-style Hero Section */
.ViewAll_heroSection__JC\\+Zb {
  width: 100%;
  margin-bottom: 3rem;
  padding: 0;
  overflow: hidden;
}

.ViewAll_heroCarousel__0FseN {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #000;
}

.ViewAll_heroSlideTrack__WIyTP {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 100%;
}

.ViewAll_heroSlide__bebdw {
  min-width: 100%;
  flex: 0 0 100%;
  overflow: hidden;
}

.ViewAll_heroContent__UnLm1 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 3rem 4rem;
  min-height: 550px;
  cursor: pointer;
  width: 100%;
}

.ViewAll_heroContent__UnLm1::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.6) 40%, 
    rgba(0, 0, 0, 0.4) 60%,
    rgba(0, 0, 0, 0.2) 80%,
    rgba(0, 0, 0, 0) 100%),
  linear-gradient(to top, 
    rgba(0, 0, 0, 0.9) 0%, 
    rgba(0, 0, 0, 0.6) 30%, 
    rgba(0, 0, 0, 0.3) 60%, 
    rgba(0, 0, 0, 0) 100%);
  z-index: 1;
}

.ViewAll_heroImageContainer__XMNh6 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
}

.ViewAll_heroImage__S\\+Gs1 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ViewAll_heroDetails__HP9Xz {
  position: relative;
  z-index: 2;
  color: #fff;
  width: 50%;
  max-width: 650px;
}

.ViewAll_heroTitle__VdMY8 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  font-weight: 700;
  line-height: 1.2;
}

.ViewAll_heroDescription__KvjHc {
  font-size: 1.1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  color: #eee;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  width: 90%;
  overflow: hidden;
}

.ViewAll_listenButton__DSkJe {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 3;
}

.ViewAll_listenButton__DSkJe:hover {
  background-color: #b2070f;
  transform: scale(1.05);
}

.ViewAll_heroControls__2maYy {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 3;
  padding: 0 2rem;
  pointer-events: none;
}

.ViewAll_heroButton__TXL1k {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.7);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  pointer-events: auto;
}

.ViewAll_heroButton__TXL1k:hover {
  background-color: rgba(229, 9, 20, 0.7);
  border-color: #E50914;
  transform: scale(1.1);
}

.ViewAll_carouselIndicators__NMsO3 {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  z-index: 3;
}

.ViewAll_indicator__JgIfb {
  width: 10px;
  height: 3px;
  border-radius: 0;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ViewAll_activeIndicator__zRqc2 {
  background-color: #E50914;
  width: 20px;
}

/* Responsive Styles */
@media screen and (max-width: 1200px) {
  .ViewAll_booksGrid__vS0E2 {
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
  }
  
  .ViewAll_heroContent__UnLm1 {
    padding: 2.5rem 3rem;
    min-height: 500px;
  }
  
  .ViewAll_heroDetails__HP9Xz {
    width: 60%;
  }
}

@media screen and (max-width: 1024px) {
  .ViewAll_booksGrid__vS0E2 {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
  }
  
  .ViewAll_heroTitle__VdMY8 {
    font-size: 2rem;
  }
}

@media screen and (max-width: 768px) {
  .ViewAll_booksGrid__vS0E2 {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 0 1rem;
  }
  
  .ViewAll_header__bu4ai {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .ViewAll_header__bu4ai h1 {
    font-size: 18px;
  }
  
  .ViewAll_heroContent__UnLm1 {
    padding: 2rem;
    min-height: 400px;
  }
  
  .ViewAll_heroDetails__HP9Xz {
    width: 80%;
  }
  
  .ViewAll_heroTitle__VdMY8 {
    font-size: 1.8rem;
    margin-bottom: 0.7rem;
  }
  
  .ViewAll_heroDescription__KvjHc {
    font-size: 0.95rem;
    margin-bottom: 1.2rem;
  }
  
  .ViewAll_listenButton__DSkJe {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }
}

@media screen and (max-width: 576px) {
  .ViewAll_container__zjhtL {
    padding-top: 4rem !important;
  }
  
  .ViewAll_booksGrid__vS0E2 {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  
  .ViewAll_heroContent__UnLm1 {
    padding: 1.5rem;
    min-height: 350px;
  }
  
  .ViewAll_heroDetails__HP9Xz {
    width: 100%;
  }
  
  .ViewAll_heroTitle__VdMY8 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  
  .ViewAll_heroDescription__KvjHc {
    font-size: 0.9rem;
    margin-bottom: 1rem;
    width: 100%;
  }
  
  .ViewAll_listenButton__DSkJe {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }
  
  .ViewAll_heroButton__TXL1k {
    width: 36px;
    height: 36px;
  }
  
  .ViewAll_header__bu4ai h1 {
    font-size: 16px;
  }
}

@media screen and (max-width: 480px) {
  .ViewAll_booksGrid__vS0E2 {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }
  
  .ViewAll_heroContent__UnLm1 {
    padding: 1rem;
    min-height: 300px;
  }
  
  .ViewAll_heroTitle__VdMY8 {
    font-size: 1.3rem;
  }
  
  .ViewAll_heroDescription__KvjHc {
    font-size: 0.8rem;
    max-height: 80px;
    overflow-y: hidden;
  }
  
  .ViewAll_carouselIndicators__NMsO3 {
    bottom: 10px;
  }
  
  .ViewAll_indicator__JgIfb {
    width: 8px;
    height: 2px;
    margin: 0 3px;
  }
  
  .ViewAll_activeIndicator__zRqc2 {
    width: 16px;
  }
  
  .ViewAll_heroButton__TXL1k {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/ViewAll.module.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;0BAUwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ViewAll.module.css - Netflix-inspired dark theme with red accents */\n.container {\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: #141414;\n  color: #ffffff;\n  min-height: 100vh;\n  padding-top: 5rem !important;\n  overflow-x: hidden;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n  padding-bottom: 12px;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header h1 {\n  font-size: 20px;\n  margin: 0;\n  color: #E50914;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.booksGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 16px;\n  padding: 0 2rem;\n  max-width: 1400px;\n  margin: 0 auto 3rem auto;\n}\n\n.bookCard {\n  border-radius: 4px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  background-color: #181818;\n  height: 100%;\n}\n\n.bookCard:hover {\n  transform: scale(1.05);\n  z-index: 2;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n}\n\n.bookImageContainer {\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 150%; /* Netflix-style aspect ratio */\n}\n\n.bookImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.bookInfo {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));\n  color: white;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.bookCard:hover .bookInfo {\n  opacity: 1;\n}\n\n.bookTitle {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #ffffff;\n}\n\n.chapterCount {\n  font-size: 12px;\n  margin: 0;\n  color: #cccccc;\n}\n\n.premiumBadge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background-color: #E50914;\n  color: #ffffff;\n  padding: 4px 8px;\n  border-radius: 2px;\n  font-size: 10px;\n  font-weight: 600;\n  z-index: 1;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 32px;\n  margin-bottom: 32px;\n  gap: 16px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.paginationButton {\n  padding: 8px 16px;\n  background-color: #E50914;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  font-weight: 500;\n}\n\n.paginationButton:hover {\n  background-color: #b2070f;\n}\n\n.paginationButton:disabled {\n  background-color: #333333;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  font-size: 14px;\n  color: #cccccc;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  font-size: 18px;\n  color: #E50914;\n}\n\n.error, .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: #E50914;\n  font-size: 18px;\n  margin: 2rem 0;\n}\n\n/* Netflix-style Hero Section */\n.heroSection {\n  width: 100%;\n  margin-bottom: 3rem;\n  padding: 0;\n  overflow: hidden;\n}\n\n.heroCarousel {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  background-color: #000;\n}\n\n.heroSlideTrack {\n  display: flex;\n  transition: transform 0.5s ease-in-out;\n  width: 100%;\n}\n\n.heroSlide {\n  min-width: 100%;\n  flex: 0 0 100%;\n  overflow: hidden;\n}\n\n.heroContent {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 3rem 4rem;\n  min-height: 550px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.heroContent::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, \n    rgba(0, 0, 0, 0.8) 0%,\n    rgba(0, 0, 0, 0.6) 40%, \n    rgba(0, 0, 0, 0.4) 60%,\n    rgba(0, 0, 0, 0.2) 80%,\n    rgba(0, 0, 0, 0) 100%),\n  linear-gradient(to top, \n    rgba(0, 0, 0, 0.9) 0%, \n    rgba(0, 0, 0, 0.6) 30%, \n    rgba(0, 0, 0, 0.3) 60%, \n    rgba(0, 0, 0, 0) 100%);\n  z-index: 1;\n}\n\n.heroImageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.heroImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.heroDetails {\n  position: relative;\n  z-index: 2;\n  color: #fff;\n  width: 50%;\n  max-width: 650px;\n}\n\n.heroTitle {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  color: #fff;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.heroDescription {\n  font-size: 1.1rem;\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n  color: #eee;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n  width: 90%;\n  overflow: hidden;\n}\n\n.listenButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 3;\n}\n\n.listenButton:hover {\n  background-color: #b2070f;\n  transform: scale(1.05);\n}\n\n.heroControls {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  transform: translateY(-50%);\n  z-index: 3;\n  padding: 0 2rem;\n  pointer-events: none;\n}\n\n.heroButton {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  font-size: 1.2rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  pointer-events: auto;\n}\n\n.heroButton:hover {\n  background-color: rgba(229, 9, 20, 0.7);\n  border-color: #E50914;\n  transform: scale(1.1);\n}\n\n.carouselIndicators {\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  right: 0;\n  z-index: 3;\n}\n\n.indicator {\n  width: 10px;\n  height: 3px;\n  border-radius: 0;\n  background-color: rgba(255, 255, 255, 0.5);\n  margin: 0 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.activeIndicator {\n  background-color: #E50914;\n  width: 20px;\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 1200px) {\n  .booksGrid {\n    grid-template-columns: repeat(5, 1fr);\n    gap: 14px;\n  }\n  \n  .heroContent {\n    padding: 2.5rem 3rem;\n    min-height: 500px;\n  }\n  \n  .heroDetails {\n    width: 60%;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .booksGrid {\n    grid-template-columns: repeat(5, 1fr);\n    gap: 12px;\n  }\n  \n  .heroTitle {\n    font-size: 2rem;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .booksGrid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    padding: 0 1rem;\n  }\n  \n  .header {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  \n  .header h1 {\n    font-size: 18px;\n  }\n  \n  .heroContent {\n    padding: 2rem;\n    min-height: 400px;\n  }\n  \n  .heroDetails {\n    width: 80%;\n  }\n  \n  .heroTitle {\n    font-size: 1.8rem;\n    margin-bottom: 0.7rem;\n  }\n  \n  .heroDescription {\n    font-size: 0.95rem;\n    margin-bottom: 1.2rem;\n  }\n  \n  .listenButton {\n    padding: 0.6rem 1.2rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .container {\n    padding-top: 4rem !important;\n  }\n  \n  .booksGrid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n  }\n  \n  .heroContent {\n    padding: 1.5rem;\n    min-height: 350px;\n  }\n  \n  .heroDetails {\n    width: 100%;\n  }\n  \n  .heroTitle {\n    font-size: 1.5rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .heroDescription {\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n    width: 100%;\n  }\n  \n  .listenButton {\n    padding: 0.5rem 1rem;\n    font-size: 0.8rem;\n  }\n  \n  .heroButton {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .header h1 {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .booksGrid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 6px;\n  }\n  \n  .heroContent {\n    padding: 1rem;\n    min-height: 300px;\n  }\n  \n  .heroTitle {\n    font-size: 1.3rem;\n  }\n  \n  .heroDescription {\n    font-size: 0.8rem;\n    max-height: 80px;\n    overflow-y: hidden;\n  }\n  \n  .carouselIndicators {\n    bottom: 10px;\n  }\n  \n  .indicator {\n    width: 8px;\n    height: 2px;\n    margin: 0 3px;\n  }\n  \n  .activeIndicator {\n    width: 16px;\n  }\n  \n  .heroButton {\n    width: 32px;\n    height: 32px;\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ViewAll_container__zjhtL`,
	"header": `ViewAll_header__bu4ai`,
	"booksGrid": `ViewAll_booksGrid__vS0E2`,
	"bookCard": `ViewAll_bookCard__-gbYz`,
	"bookImageContainer": `ViewAll_bookImageContainer__gXGU-`,
	"bookImage": `ViewAll_bookImage__o7yIZ`,
	"bookInfo": `ViewAll_bookInfo__Vph5r`,
	"bookTitle": `ViewAll_bookTitle__Ze5aU`,
	"chapterCount": `ViewAll_chapterCount__6Qw8n`,
	"premiumBadge": `ViewAll_premiumBadge__rFdEW`,
	"pagination": `ViewAll_pagination__AsFrK`,
	"paginationButton": `ViewAll_paginationButton__42lMZ`,
	"pageInfo": `ViewAll_pageInfo__Okbu1`,
	"loading": `ViewAll_loading__9FBWs`,
	"error": `ViewAll_error__Q6V-5`,
	"noResults": `ViewAll_noResults__P8wpC`,
	"heroSection": `ViewAll_heroSection__JC+Zb`,
	"heroCarousel": `ViewAll_heroCarousel__0FseN`,
	"heroSlideTrack": `ViewAll_heroSlideTrack__WIyTP`,
	"heroSlide": `ViewAll_heroSlide__bebdw`,
	"heroContent": `ViewAll_heroContent__UnLm1`,
	"heroImageContainer": `ViewAll_heroImageContainer__XMNh6`,
	"heroImage": `ViewAll_heroImage__S+Gs1`,
	"heroDetails": `ViewAll_heroDetails__HP9Xz`,
	"heroTitle": `ViewAll_heroTitle__VdMY8`,
	"heroDescription": `ViewAll_heroDescription__KvjHc`,
	"listenButton": `ViewAll_listenButton__DSkJe`,
	"heroControls": `ViewAll_heroControls__2maYy`,
	"heroButton": `ViewAll_heroButton__TXL1k`,
	"carouselIndicators": `ViewAll_carouselIndicators__NMsO3`,
	"indicator": `ViewAll_indicator__JgIfb`,
	"activeIndicator": `ViewAll_activeIndicator__zRqc2`
};
export default ___CSS_LOADER_EXPORT___;
